import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=1506d456&scoped=true"
import script from "./InfoBanner.vue?vue&type=script&lang=js"
export * from "./InfoBanner.vue?vue&type=script&lang=js"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=1506d456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506d456",
  null
  
)

export default component.exports